export default __webpack_public_path__ + "static/media/img-b-root@3x.41a44e8c.jpg";